import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-500 flex-wrap">
      <Link to="/" className="hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-home-4-line text-xs"></i>
        </div>
      </Link>
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-1.5 whitespace-nowrap">
          <span className="text-foreground-300">/</span>
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-600 transition-colors duration-200">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}